import { shortenUrl } from "../Services/ShortUrlService";
import WebShareHelper from "./WebShareHelper";

export function shortAndShareEntityOnMobile(
    groupId: string,
    postId: string,
    entityTitle: string,
    failCallback?: () => void,
    successCallback?: () => void,
) {
    shortenUrl(groupId, postId).then((shortLinkInfo) => {
        if (WebShareHelper.isAvailable()) {
            const shareWindow = WebShareHelper.init({
                title: `Die CHECK24-Tippspiel Community`,
                text: `Entdecke neue Community Beiträge aus der Gruppe ${entityTitle} ᛫ ${encodeURI(
                    shortLinkInfo.short,
                )}`,
            });
            shareWindow.openDialog();
            successCallback && successCallback();
        } else {
            failCallback && failCallback();
        }
    });
}
